import React from 'react'
import PropTypes from 'prop-types'
import { Provider, inject, observer } from 'mobx-react'
import Store from './stores/Store.js'
import BackdropCategory from './components/BackdropCategory'
import './index.scss'

const DEFAULT_PER_PAGE = 12

@inject("widgetStore")
@observer
export default class PhotoboothBackgroundList extends React.Component {
  static propTypes = {
    widgetStore: PropTypes.object.isRequired,
    showBookNowButton: PropTypes.bool,
    bookNowButtonText: PropTypes.string,
    showPrice: PropTypes.bool,
    buttonBackgroundColor: PropTypes.string,
    buttonForegroundColor: PropTypes.string,
    fontFamily: PropTypes.string,
    textColor: PropTypes.string,
    perPage: PropTypes.number,
  }

  static defaultProps = {
    showBookNowButton: true,
    bookNowButtonText: "Book Now",
    showPrice: true,
    showTitle: true,
    perPage: DEFAULT_PER_PAGE,
  }

  photoboothBackgroundStore = new Store({ widgetStore: this.props.widgetStore })

  componentDidMount() {
    this.photoboothBackgroundStore.setup()
  }

  render() {
    const { photoboothBackgroundStore } = this
    const { showBookNowButton, bookNowButtonText, showPrice, showTitle, perPage, buttonBackgroundColor, buttonForegroundColor, textColor, fontFamily  } = this.props
    const { ready, loading, backdropCategories, photoboothBackgrounds } = photoboothBackgroundStore

    if(!ready) {
      return null
    }
    else if(loading) {
      return (
        <div>Loading...</div>
      )
    }
    else {
      return (
        <Provider store={photoboothBackgroundStore}>
          <div className="cc-widget-wrapper">
            { backdropCategories.map(backdropCategory =>
              <BackdropCategory
                key={backdropCategory.id}
                backdropCategory={backdropCategory}
                showBookNowButton={showBookNowButton}
                bookNowButtonText={bookNowButtonText}
                showPrice={showPrice}
                showTitle={showTitle}
                perPage={perPage}
                fontFamily={fontFamily}
                textColor={textColor}
                buttonBackgroundColor={buttonBackgroundColor}
                buttonForegroundColor={buttonForegroundColor}
              />
            )}
          </div>
        </Provider>
      )
    }
  }
}
